export default __webpack_public_path__ + "static/media/worng.a099ecfb.svg";